export default __webpack_public_path__ + "images/IG.5022aa4.png";